import {BASE_SINGLE_ARG_NUMERIC_FUNCTION} from 'pipelines/formula/functions/BaseFunctions';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  ...BASE_SINGLE_ARG_NUMERIC_FUNCTION,
  name: 'EXP',
  description: 'Exponential of a single number or each number in a column using the constant e as the base.',
  shortDescription: 'Exponential',
} satisfies AnalysisFunction;
